import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { UserLanguageType } from '@api/types';
import { PostRequestArgsType } from '@api/v1/types';
import { withTryCatch } from '@api/v1/error-handlers';

export type PostCurrentUserLanguagePayloadType = (
  Pick<UserLanguageType, 'languageCode' | 'proficiencyUid' | 'displayOrder'>
);

export const apiAddCurrentUserLanguage = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostCurrentUserLanguagePayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.currentUserLanguages(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteCurrentUserLanguage = async ({
  userLanguageId,
  errorConfig = {},
  callbacks = {},
}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.currentUserLanguages({ userLanguageId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
